const STORAGE_PREFIX = 'docs-sidebar-groups:';

const getStorageKey = (scope) => {
    return `${STORAGE_PREFIX}${scope || 'default'}`;
};

const readState = (scope) => {
    try {
        return JSON.parse(window.localStorage.getItem(getStorageKey(scope)) || '{}');
    } catch (error) {
        return {};
    }
};

const writeState = (scope, state) => {
    try {
        window.localStorage.setItem(getStorageKey(scope), JSON.stringify(state));
    } catch (error) {
        // Ignore localStorage failures.
    }
};

const setGroupOpenState = (toggle, isOpen) => {
    const groupItem = toggle.closest('.docs-sidebar-nav-item--group');
    const children = groupItem?.querySelector(':scope > [data-docs-group-children]');

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (children) {
        children.classList.toggle('is-open', isOpen);
    }
};

export default function initDocsSidebar() {
    document.querySelectorAll('[data-docs-sidebar]').forEach((sidebar) => {
        const scope = sidebar.getAttribute('data-docs-sidebar-scope') || 'default';
        const state = readState(scope);

        sidebar.querySelectorAll('[data-docs-group-toggle]').forEach((toggle) => {
            const groupId = toggle.getAttribute('data-docs-group-id');
            const hasStoredState = groupId && Object.prototype.hasOwnProperty.call(state, groupId);
            const defaultOpen = toggle.getAttribute('aria-expanded') === 'true';

            setGroupOpenState(toggle, hasStoredState ? Boolean(state[groupId]) : defaultOpen);

            toggle.addEventListener('click', () => {
                const nextState = toggle.getAttribute('aria-expanded') !== 'true';

                setGroupOpenState(toggle, nextState);

                if (groupId) {
                    state[groupId] = nextState;
                    writeState(scope, state);
                }
            });
        });
    });
}
